import { Minus, Plus, Trash2 } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useCartActions } from '@/hooks/useCart'
import { useCartStore } from '@/store/cartStore'
import type { CartItem } from '@/types/order'

interface CartItemRowProps {
  item: CartItem
}

export function CartItemRow({ item }: CartItemRowProps) {
  const { updateQuantity, remove } = useCartActions()
  const closeDrawer = useCartStore((s) => s.closeDrawer)

  return (
    <div className="flex gap-3">
      {/* Thumbnail */}
      <Link
        to={`/listing/${item.listingId}`}
        onClick={closeDrawer}
        className="flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden bg-slate-100"
      >
        {item.image ? (
          <img
            src={item.image}
            alt={item.title}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-400 text-2xl">
            📷
          </div>
        )}
      </Link>

      {/* Info */}
      <div className="flex-1 min-w-0">
        <Link
          to={`/listing/${item.listingId}`}
          onClick={closeDrawer}
          className="text-sm font-medium text-slate-900 hover:text-primary-600 line-clamp-2"
        >
          {item.title}
        </Link>
        <p className="text-sm font-semibold text-slate-900 mt-1">
          ${item.price.toFixed(2)}
        </p>

        {/* Quantity controls */}
        <div className="flex items-center gap-2 mt-2">
          <button
            onClick={() => updateQuantity(item.id, item.quantity - 1)}
            className="w-7 h-7 flex items-center justify-center rounded border border-slate-300 hover:bg-slate-100 text-slate-600"
            aria-label="Decrease quantity"
          >
            <Minus className="w-3.5 h-3.5" />
          </button>
          <span className="text-sm font-medium w-6 text-center">
            {item.quantity}
          </span>
          <button
            onClick={() => updateQuantity(item.id, item.quantity + 1)}
            className="w-7 h-7 flex items-center justify-center rounded border border-slate-300 hover:bg-slate-100 text-slate-600"
            aria-label="Increase quantity"
          >
            <Plus className="w-3.5 h-3.5" />
          </button>

          <button
            onClick={() => remove(item.id)}
            className="ml-auto p-1 text-slate-400 hover:text-red-500"
            aria-label="Remove item"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
